import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { I18nextProvider } from "react-i18next";

//styles
import "./assets/styles/global.scss";
import "animate.css";
import "react-toastify/dist/ReactToastify.css";

// required for babel polyfills
import "regenerator-runtime/runtime";

//translation setup
import i18n from "./utils/i18n";

//language router
import LangRouter from "./routing/LangRouter";
import { persistor, store } from "./configureStore";
import { PersistGate } from "redux-persist/integration/react";
const container = document.getElementById("root"),
    root = createRoot(container);

root.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <BrowserRouter forceRefresh future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
                <I18nextProvider i18n={i18n}>
                    <LangRouter />
                </I18nextProvider>
            </BrowserRouter>
        </PersistGate>
    </Provider>,
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorkerRegistration.register();
// if ("serviceWorker" in navigator) {
//     window.addEventListener("load", () => {
//         navigator.serviceWorker
//             .register("/service-worker.js")
//             .then(registration => {
//                 console.log("Service Worker registered with scope:", registration.scope);

//                 // Listen for updates to the service worker
//                 registration.onupdatefound = () => {
//                     const installingWorker = registration.installing;
//                     console.log("A new service worker is being installed:", installingWorker);

//                     installingWorker.onstatechange = () => {
//                         if (installingWorker.state === "installed") {
//                             if (navigator.serviceWorker.controller) {
//                                 // New content available
//                                 console.log("New content is available, please refresh.");
//                                 const event = new CustomEvent("newContentAvailable");
//                                 window.dispatchEvent(event);
//                             } else {
//                                 console.log("Content cached for offline use.");
//                             }
//                         }
//                     };
//                 };
//             })
//             .catch(error => {
//                 console.error("Service Worker registration failed:", error);
//             });
//     });
// }
